// // import FeatureProduct from "./FeatureProduct";
// import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
// // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// // import ProductList from "../products/ProductList";
// import ProductListCard from "./ProductListCard";
// import ProductGridCard from "./ProductGridCard";
// import BannerCard from "./BannerCard";
// import ProductFullWidthCard from "./ProductFullWidthCard";
// import TextCardView from "./TextCardView";
// import YouTubecard from "./YouTubecard";

// import CustomerReview from "../components/CustomerReview";
// import images from "../Images/doctor.png";
// import {
//   ROLE,
//   USER_ROLE,
//   TOP_BANNER,
//   TOP_PRODUCT,
//   CARD_VIEW,
//   ABOUT_US_VIEW,
//   BRAND_HEADING_VIEW,
//   full_width_card_view,
//   you_tube_view,
//   CARD_VIEW_WITH_TEXT,
//   CUSTOMER_REVIEW,
//   you_tube_view01,
//   Article_view,
//   article_view_01,
//   FULL_BODY_CHEAKUP,
//   CART_COUNT,
// } from "../Constant";
// // import ProductItemCart from "../landing/ProductItemCart";

// import BrandHeadingView from "./BrandHeadingView";
// import InstagramCarousel from "../social/InstagramPosts";
// import ArticleCard from "./ArticleCard";
// import FullBodyCheakup from "./fullBodyCheckp/FullBodyCheakup";
// import CashLessPolicy from "./CashLessPolicy";
// import Ourservices from "./ourservices/Ourservices";
// import NoteBoard from "../noteboard/NoteBoard";
// import Topproduct from "../minicard/Topproduct";
// import Minicard from "../minicard/Minicard";
// import { increment, handleLoggin } from "../actions";
// import { useDispatch, useSelector } from "react-redux";

// function Landing({ listData, testData, topproduct }) {
//   const one = TOP_PRODUCT;
//   const navigate = useNavigate();
//   const editMode = useSelector((state) => state.editMode.editMode);
//   // const bannerItemRemoved = listData.splice(0, 1);
//   const myData = localStorage.getItem("cat_ascending_data");
//   const catItemList = JSON.parse(myData);
//   const [catListData, setCatListData] = useState([]);

//   useEffect(() => {
//     if (listData.length > 0) {
//       setCatListData(listData);
//     } else if (catItemList.length > 0) {
//       setCatListData(catItemList);
//     } else {
//       setCatListData(null);
//     }
//   }, []);

//   const data = [
//     {
//       Image: { images },
//       nama: "hello",
//       bgcolor: "red",
//       Imaseclick: "/",
//     },
//   ];

//   return (
//     <div style={{ minHeight: "100vh" }}>
//       <ScrollToTopOnMount />
//       {/* <> */}
//       {catListData?.map((item, index) => (
//         // <div>
//         //   {
//         //     <>
//         //       {
//         <>
//           {item?.viewType === TOP_BANNER ? (
//             <div className="container-fluid" style={{ overflow: "hidden" }}>
//               {/* <div className="  justify-contet-center  mt-5 pt-5">
//                 <Topproduct
//                   item={topproduct}
//                   rowItem={3}
//                   key={item.id}
//                   navigate={navigate}
//                   showEdit={editMode}
//                 />

//                 <Ourservices />
//                 <BannerCard
//                   key={item.id}
//                   item={item}
//                   navigate={navigate}
//                   showEdit={editMode}
//                   nama={TOP_BANNER}
//                 />
//                 <NoteBoard
//                   Text={"Get active and be a healthy weight."}
//                   Text_02={" Do not get thirsty,Do not skip breakfast"}
//                 />
//               </div> */}
//             </div>
//           ) : (
//             <div div className="container">
//               <div>
//                 {item?.viewType === BRAND_HEADING_VIEW ? (
//                   <div>
//                     {/* <BrandHeadingView
//                       key={item.id}
//                       item={item}
//                       showEdit={editMode}
//                       nama={BRAND_HEADING_VIEW}
//                     /> */}
//                   </div>
//                 ) : (
//                   <div>
//                     {item?.viewType === TOP_PRODUCT ? (
//                       <div>
//                         {/* <ProductGridCard
//                           key={item.id}
//                           item={item}
//                           navigate={navigate}
//                           showEdit={editMode}
//                           nama={TOP_PRODUCT}
//                         /> */}
//                       </div>
//                     ) : (
//                       <div>
//                         <div>
//                           {item?.viewType === CARD_VIEW ? (
//                             <div>
//                               {/* <ProductListCard
//                                 key={item.id}
//                                 item={item}
//                                 navigate={navigate}
//                                 showEdit={editMode}
//                                 nama={CARD_VIEW}
//                               /> */}
//                             </div>
//                           ) : (
//                             <div>
//                               {item?.viewType === "TestByCategroy" ? (

//                                 <div>
//                                   {/* <Minicard
//                                     item={testData}
//                                     Text={item}
//                                     rowItem={3}
//                                     key={item.id}
//                                     navigate={navigate}
//                                     showEdit={editMode}
//                                     nama={CARD_VIEW_WITH_TEXT}
//                                   /> */}
//                                 </div>
//                               ) : (
//                                 <div>
//                                   {item?.viewType === full_width_card_view ? (
//                                     <div>
//                                       {/* <ProductFullWidthCard
//                                         item={item}
//                                         showEdit={editMode}
//                                         nama={full_width_card_view}
//                                       /> */}
//                                     </div>
//                                   ) : (
//                                     <div>
//                                       {item?.viewType === you_tube_view ? (
//                                         <div>
//                                           {/* <YouTubecard
//                                             key={item.id}
//                                             item={item}
//                                             navigate={navigate}
//                                             showEdit={editMode}
//                                             nama={you_tube_view}
//                                           /> */}
//                                         </div>
//                                       ) : (
//                                         <div>
//                                           {item?.viewType ===
//                                           CARD_VIEW_WITH_TEXT ? (
//                                             <div>
//                                               {/* <TextCardView
//                                                 key={item.id}
//                                                 item={item}
//                                                 navigate={navigate}
//                                                 showEdit={editMode}
//                                                 nama={CARD_VIEW_WITH_TEXT}
//                                               /> */}
//                                             </div>
//                                           ) : (
//                                             <div>
//                                               {item?.viewType ===
//                                               CUSTOMER_REVIEW ? (
//                                                 <div>
//                                                   <CustomerReview
//                                                     key={item.id}
//                                                     item={item}
//                                                     navigate={navigate}
//                                                     showEdit={editMode}
//                                                     nama={CUSTOMER_REVIEW}
//                                                   />
//                                                 </div>
//                                               ) : (
//                                                 <div>
//                                                   {item?.viewType ===
//                                                   you_tube_view01 ? (
//                                                     <div>
//                                                       {/* {editMode ? (
//                                                         <YouTubecard
//                                                           key={item.id}
//                                                           item={item}
//                                                           navigate={navigate}
//                                                           showEdit={editMode}
//                                                           nama={you_tube_view01}
//                                                         />
//                                                       ) : null} */}
//                                                     </div>
//                                                   ) : (
//                                                     <div>
//                                                       {item?.viewType ===
//                                                       article_view_01 ? (
//                                                         <div style={{marginTop:150}}>
//                                                           {/* <NoteBoard
//                                                             Text={
//                                                               "Limit alcohol use. Alcohol is high in calories and may worsen health conditions common among older adults."
//                                                             }
//                                                           />
//                                                           <CashLessPolicy /> */}
//                                                           <ProductGridCard
//                                                             key={item.id}
//                                                             item={item}
//                                                             navigate={navigate}
//                                                             showEdit={editMode}
//                                                             nama={
//                                                               article_view_01
//                                                             }
//                                                           />

//                                                           {/* <InstagramCarousel/> */}
//                                                         </div>
//                                                       ) : (
//                                                         <div>
//                                                           {item?.viewType ===
//                                                           "InstagramPosts" ? (
//                                                             // <div>
//                                                             //   <InstagramCarousel
//                                                             //     key={item.id}
//                                                             //     item={item}
//                                                             //     navigate={
//                                                             //       navigate
//                                                             //     }
//                                                             //     showEdit={
//                                                             //       showEdit
//                                                             //     }
//                                                             //   />
//                                                             // </div>
//                                                             ""
//                                                           ) : (
//                                                             <div>
//                                                               {item?.viewType ===
//                                                               FULL_BODY_CHEAKUP ? (
//                                                                 <div>
//                                                                   {/* <FullBodyCheakup
//                                                                     key={
//                                                                       item.id
//                                                                     }
//                                                                     item={item}
//                                                                     navigate={
//                                                                       navigate
//                                                                     }
//                                                                     showEdit={
//                                                                       editMode
//                                                                     }
//                                                                     nama={
//                                                                       FULL_BODY_CHEAKUP
//                                                                     }
//                                                                   /> */}
//                                                                   {/* <CashLessPolicy /> */}
//                                                                 </div>
//                                                               ) : (
//                                                                 <div> </div>
//                                                               )}
//                                                             </div>
//                                                           )}
//                                                         </div>
//                                                       )}
//                                                     </div>
//                                                   )}
//                                                 </div>
//                                               )}
//                                             </div>
//                                           )}
//                                         </div>
//                                       )}
//                                     </div>
//                                   )}
//                                 </div>
//                               )}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </>
//         //       }
//         //     </>
//         //   }
//         // </div>
//       ))}
//       {/* </> */}
//     </div>
//   );
// }

// export default Landing;

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { USER_INFO, USER_ROLE } from "../Constant";

const Landing = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isLogged = useSelector((state) => state.isLogged);
  const navigate = useNavigate();
   const userRole = localStorage.getItem(USER_INFO);


  // useEffect(() => {
      
      

  //   if ( !userRole) {
     
  //     navigate("/login");
  //   }
  // }, []);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeInAnimation = {
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(20px)",
    transition: "opacity 0.8s ease-in, transform 0.8s ease-out",
  };

  const slideInAnimation = {
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateX(0)" : "translateX(-50px)",
    transition: "opacity 0.8s ease-in, transform 0.8s ease-out",
    transitionDelay: "0.3s",
  };

  return (
    <div
      className="hero-section position-relative overflow-hidden"
      style={{ marginTop: 100 }}
    >
      {/* Background with overlay */}
      <div
        className="bg-image w-100"
        style={{
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <div className="container h-100">
          <div className="row h-100 align-items-center py-5">
            {/* Left column with text content */}
            <div
              className="col-lg-6 text-center text-lg-start"
              style={fadeInAnimation}
            >
              <h1 className="display-4 fw-bold text-primary mb-4">
                <span className="text-info">DI Health </span> Advanced
                Healthcare Management
              </h1>
              <p className="lead mb-4">
                Pioneering the future of healthcare delivery with cutting-edge
                technology and compassionate care.
              </p>

              {/* Stats Section */}
              <div className="row mt-5 g-3 text-center text-lg-start">
                {[
                  { number: "99.9%", text: "System Uptime" },
                  { number: "10K+", text: "Patients Managed Daily" },
                  { number: "10+", text: "Hospitals Onboarded" },
                ].map((stat, index) => (
                  <div
                    className="col-sm-4"
                    key={index}
                    style={{
                      ...slideInAnimation,
                      transitionDelay: `${0.5 + index * 0.2}s`,
                    }}
                  >
                    <h2 className="fw-bold text-primary">{stat.number}</h2>
                    <p className="text-muted mb-0">{stat.text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right column with features */}
            <div
              className="col-lg-6 d-none d-lg-block"
              style={slideInAnimation}
            >
              <div className="row g-3">
                {[
                  {
                    icon: "🏥",
                    title: "State-of-the-art Facilities",
                    desc: "Modern equipment and comfortable environments",
                  },
                  {
                    icon: "👨‍⚕️",
                    title: "Expert Team",
                    desc: "Experienced doctors and caring staff",
                  },
                  {
                    icon: "⚡",
                    title: "Quick Response",
                    desc: "Rapid and efficient emergency services",
                  },
                  {
                    icon: "📱",
                    title: "Digital Health Records",
                    desc: "Secure and accessible patient information",
                  },
                ].map((feature, index) => (
                  <div
                    className="col-6"
                    key={index}
                    style={{
                      ...fadeInAnimation,
                      transitionDelay: `${0.7 + index * 0.2}s`,
                    }}
                  >
                    <div className="p-4 bg-white rounded-3 shadow-sm h-100">
                      <div className="display-5 mb-3">{feature.icon}</div>
                      <h5 className="mb-2">{feature.title}</h5>
                      <p className="text-muted mb-0 small">{feature.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
